import * as fromAuth from '../auth/store/auth.reducer';
import * as fromObservations from '../observations/store/observation.reducer';
import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
  auth: fromAuth.State;
  observations: fromObservations.State;
}

export const appReducer: ActionReducerMap<AppState> = {
  auth: fromAuth.authReducer,
  observations: fromObservations.observationReducer,
};
